'use client'

import { useEffect } from 'react'
import { useAuthStore } from '@/stores/authStore'

export default function AuthInitializer({ children }: { children: React.ReactNode }) {
  const { checkAuth, token, isAuthenticated, isHydrated, setHydrated } = useAuthStore()

  // Handle hydration
  useEffect(() => {
    setHydrated(true)
  }, [setHydrated])

  // Check auth when token becomes available after hydration
  useEffect(() => {
    if (isHydrated && token && !isAuthenticated) {
      checkAuth()
    }
  }, [isHydrated, token, isAuthenticated, checkAuth])

  return <>{children}</>
} 